<template>
  <div>
    <top-header></top-header>
    <p class="recharge-balance-p">
      <span>账户余额：</span>
      <span style="color: #5daf34">{{curBalance}}元</span>
    </p>
    <div style="margin-left: 50px">
      <!--<div>-->
      <!--<span>支付宝</span>-->
      <!--<img src="../../assets/recharge/recharge_way_alipay.jpg" style="vertical-align:middle;" height="60"/>-->
      <!--</div>-->
      <el-radio-group v-model="rechargeWay" @change="rechargeWayChange">
        <el-radio label='alipay' style="margin-top: 20px">
          <img src="../../assets/recharge/recharge_way_alipay.jpg" style="vertical-align:middle;" height="60"/>
        </el-radio>
        <el-radio label='wechatpay' style="margin-top: 20px">
          <img src="../../assets/recharge/recharge_way_wechatpay.jpg" style="vertical-align:middle;" height="60"/>
        </el-radio>
        <el-radio label='bank' style="margin-top: 20px">
          <img src="../../assets/recharge/recharge_way_bank.jpg" style="vertical-align:middle;" height="60"/>
        </el-radio>
        </el-radio-group>
    </div>
    <div v-if="isBankWay" style="padding-top: 50px;">
      <p class="recharge-bank-way-title">转账账号信息:</p>
      <p class="recharge-bank-way-item"><span style="">账户名称：</span><span style="margin-left: 50px">北京知行云课网络科技有限公司</span></p>
      <p class="recharge-bank-way-item"><span style="">开户号码：</span><span style="margin-left: 50px">110938623210101</span></p>
      <p class="recharge-bank-way-item"><span style="">开户银行：</span><span style="margin-left: 50px">招商银行股份有限公司北京首体支行</span></p>
    </div>
    <div class="recharge-balance-radio-div" v-else>
      <el-radio-group v-model="rechargeRadioValue">
        <el-radio :label="0" class="recharge-balance-radio">
          <span class="recharge-balance-radio-span">自定义金额：</span>
          <el-input step="0.01" size="small" placeholder="请输入充值金额" style="width: 200px"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
                    v-model="customRechargeValue"></el-input>
        </el-radio><br>
        <el-radio :label="200" class="recharge-balance-radio"><span class="recharge-balance-radio-span">200元</span></el-radio><br>
        <el-radio :label="500" class="recharge-balance-radio"><span class="recharge-balance-radio-span">500元</span></el-radio><br>
        <el-radio :label="1000" class="recharge-balance-radio"><span class="recharge-balance-radio-span">1000元</span></el-radio><br>
        <el-radio :label="2000" class="recharge-balance-radio"><span class="recharge-balance-radio-span">2000元</span></el-radio><br>
        <el-radio :label="5000" class="recharge-balance-radio"><span class="recharge-balance-radio-span">5000元</span></el-radio>
      </el-radio-group><br>
      <el-button type="primary" class="recharge-balance-btn" @click="rechargeBalanceClick">立即充值</el-button>
    </div>
    <el-dialog title="微信支付" :visible.sync="dialogWeChatVisible" append-to-body :close-on-click-modal="false" @close="closeWxQrCode">
      <we-chat-q-r-code v-if="wxQRCodeVisible" ref="wxRqCode"
                        v-bind:ordernum="weChatPayOderNum" v-bind:feeNum="feeNum"
                        v-bind:rqcodeUrl="weChatRqCodeUrl"></we-chat-q-r-code>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
import WeChatQRCode from './WeChatQRCode'
export default {
  name: 'Recharge',
  components: {WeChatQRCode, TopHeader},
  data () {
    return {
      rechargeRadioValue: 0,
      curBalance: 1024,
      customRechargeValue: null,
      rechargeWay: 'alipay',
      isBankWay: false,
      dialogWeChatVisible: false,
      wxQRCodeVisible: false,
      weChatRqCodeUrl: '',
      weChatPayOderNum: '',
      feeNum: ''
    }
  },
  created () {
    this.getCurBalance()
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/recharge') {
          console.log('----', route.path)
          that.getCurBalance()
        }
      },
      deep: true
    }
  },
  methods: {
    getCurBalance () {
      this.$api.recharge.getCurBalance().then((res) => {
        this.curBalance = res.data.balance
      })
    },
    rechargeWayChange () {
      if (this.rechargeWay === 'bank') {
        this.isBankWay = true
      } else {
        this.isBankWay = false
      }
    },
    rechargeBalanceClick () {
      let rechargeBalance = 0
      if (this.rechargeRadioValue === 0) {
        if (this.customRechargeValue === null) {
          this.$message.error('请输入充值金额')
          return
        } else {
          rechargeBalance = this.customRechargeValue
        }
      } else {
        rechargeBalance = this.rechargeRadioValue
      }
      let requestData = {fee: rechargeBalance}
      if (this.rechargeWay === 'alipay') {
        this.$api.recharge.rechargeAlipay(requestData).then((res) => {
          if (res.code === 0) {
            let url = res.url
            if(url !== undefined && url !== '') {
              // window.open(url,'_blank')
              window.location.href = url
            }
          }
        })
      } else if(this.rechargeWay === 'wechatpay') {
        this.$api.recharge.rechargeWeChat(requestData).then((res) => {
          if (res.code == 0) {
            // this.weChatRqCodeUrl = 'weixin://wxpay/bizpayurl?pr=uPc4tSN'
            this.weChatRqCodeUrl = res['wechatpay_url']
            this.weChatPayOderNum = res.ordreno
            this.feeNum = res.fee
            this.dialogWeChatVisible = true
            this.wxQRCodeVisible = true
            let that = this
            if(this.$refs.weChatRqCode === undefined) {
              setTimeout(function () {
                that.$refs.wxRqCode.initQRCode()
              },100)
            }
          }
        })

      }
    },
    closeWxQrCode () {
      this.wxQRCodeVisible = false
    }
  }
}
</script>

<style scoped>
  .recharge-bank-way-title{
    font-family: "Microsoft Yahei", sans-serif;
    font-size: 24px;
    color: #000000;
    margin-left: 50px;
    margin-top: 40px;
  }
  .recharge-bank-way-item{
    font-family: "Microsoft Yahei", sans-serif;
    font-size: 18px;
    color: #000000;
    margin-left: 50px;
    margin-top: 20px;
  }
  .recharge-balance-p{
    padding-top: 50px;
    padding-left: 50px;
    font-size: 20px;
    font-weight:bold;
  }
  .recharge-balance-radio-div{
    padding-left: 50px;
    padding-top: 50px;
  }
  .recharge-balance-radio{
    font-size: 20px;
    font-weight:bold;
    padding-top: 20px;
  }
  .recharge-balance-radio-span{
    font-size: 17px;
    font-weight:bold;
  }
  .recharge-balance-btn{
    margin-top: 20px;
  }
  .recharge-icon{
    height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/page/financedManager/Recharge.vue